// Components==============
import EvidenceCard from 'components/UI/EvidenceCard/EvidenceCard';
import GroowTorialCard from 'components/UI/GroowTorialCard/GroowTorialCard';
import { useMeasure } from 'hooks/useMeasure';
import { useMediaQ } from 'hooks/useMediaQ';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useRef } from 'react';
import { GlobalEvidenceContext } from 'utilities/GlobalContext/GlobalEvidence';
import './BottomCards.module.scss';
// =========================

export default function BottomCards() {
  const translate = useTranslate();

  const evidence = useContext(GlobalEvidenceContext);

  const evidenceEntity = evidence?.[0];
  const groowtorial = useRedux((state) => state.groowtorial?.entities.byId[1]);
  const fallbackGroowtorial = useRedux(
    (state) => state.groowtorial?.entities.byId[2]
  );

  const groowtorialRef = useRef<HTMLDivElement>(null);
  const { height } = useMeasure(groowtorialRef);

  const query = useMediaQ('min', 525);

  return (
    <div styleName="wrapper">
      <div styleName="cards">
        <div>
          <strong>
            {`${translate('general.terms.interesting-groowtorial')}${
              !evidenceEntity ? 's' : ''
            }`}
          </strong>
          <div styleName={!evidenceEntity ? 'no-evidence' : ''}>
            <GroowTorialCard
              groowTorial={groowtorial}
              reference={groowtorialRef}
            />
            {!evidenceEntity && (
              <GroowTorialCard groowTorial={fallbackGroowtorial} />
            )}
          </div>
        </div>
        {!!evidenceEntity && (
          <div>
            <strong>{translate('general.terms.latest-uploaded-work')}</strong>
            <EvidenceCard
              evidence={evidenceEntity.evidence}
              height={query ? `${height}px` : '200px'}
            />
          </div>
        )}
      </div>
    </div>
  );
}
